// extracted by mini-css-extract-plugin
export default {"even":"Style_even__eOZRw","odd":"Style_odd__KpR3-","headingTitle":"Style_headingTitle__RA3qw","ratingValue":"Style_ratingValue__gYqSN","TableClass":"Style_TableClass__SxoAz"};